import { FunctionComponent, SVGProps } from 'react'
import cx from 'classnames'

import SharedStyles from '../../Security/SecuritySettings.module.scss'
import Styles from './ActionableInput.module.scss'

import { camelCase } from 'lodash'
import { Button } from 'blaze-ui/Button/Button'

interface InputAction {
  title: string
  onClick: () => void
  icon?: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>>
}

interface Props {
  label: string
  withLabel?: boolean
  value: string
  id?: string
  isDisabled?: boolean
  actions: InputAction[]
  isFreePlanOrStarterPlan?: boolean
}

export const ActionableInput = ({ label, withLabel = true, value, isDisabled, id, actions, isFreePlanOrStarterPlan = false }: Props) => {
  const actionsComponents = actions.map((action) => (
    <Button
      frontIcon={action.icon}
      key={action.title}
      onPress={action.onClick}
      variant="secondary"
      size="sm"
      data-testid={camelCase(`${label} ${action.title}`)}
    >
      {action.title}
    </Button>
  ))

  return (
    <div className={cx(SharedStyles.settingsOption, { [SharedStyles.disabled]: isDisabled })}>
      <div className={SharedStyles.inputRow}>
        {withLabel && (
          <label className={SharedStyles.optionHeader} htmlFor={id}>
            {label}
          </label>
        )}
        <div className={Styles.inputWithActions}>
          <div className={Styles.inputWrapper}>
            <input type="text" disabled value={isFreePlanOrStarterPlan ? 'Link will appear here when you update' : value} id={id} data-testid={camelCase(label)} />
          </div>
          {actions?.length && <div className={Styles.inputActions}>{actionsComponents}</div>}
        </div>
      </div>
    </div>
  )
}
